import React from 'react';
import style from './css/audience.module.css';
import { FaLaptopCode } from "react-icons/fa6";
import { GiGraduateCap } from "react-icons/gi";
import { MdShoppingBag } from "react-icons/md";

const audienceList = [
  {
    icon: <FaLaptopCode />,
    title: 'Beginners',
    description: ' Beginners looking to start a career in IT',
  },
  {
    icon: <GiGraduateCap />,
    title: 'Students & Graduates',
    description: 'Students & graduates seeking tech skills that employers want',
  },
  {
    icon: <MdShoppingBag />,
    title: 'Professionals',
    description: 'Professionals looking to upskill and switch to a tech career',
  },
];

export default function Audience() {
  return (
    <section className={style.audienceSection}>
    <h2 className={style.sectionTitle}>Who is this for?</h2>
    <div className={style.timelineContainer}>
      <div className={style.line}></div>
      <div className={style.cardContainer}>
        {audienceList.map((aud, index) => (
          <div className={style.cardWrapper} key={index}>
            <div className={style.stepCircle}>{index + 1}</div>
            <div className={style.card}>
              <div className={style.icon}>{aud.icon}</div>
              <h3>{aud.title}</h3>
              <p>{aud.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
  );
}